<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{ $route.meta.title }}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{path: '/'}">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">搜索</template>

      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">

        <div class="re-el-form__flex">
          <el-form-item label="用户名称"
                        key="user_id"
                        prop="user_id">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入用户名称搜索"
              v-model="search.user_id"
              :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1}))"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>

          <el-form-item label="账户名称"
                        prop="name">
            <el-input style="width: 100%;"
                      v-model="search.name"
                      clearable
                      placeholder="请输入账户名称搜索">
            </el-input>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置</el-button>

        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <div class="margin b15">
        <el-button type="primary"
                   @click="createUserBank"
                   size="small">添加员工账户
        </el-button>

        <el-button type="primary"
                   @click="batchCreateUserBank"
                   size="small">批量添加
        </el-button>

        <el-button type="primary"
                   @click="batchEditUserBank"
                   size="small">批量修改
        </el-button>

        <el-button type="primary"
                   size="small"
                   @click="onExportSearch()">按搜索结果导出
        </el-button>
      </div>

      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         key="id"
                         label="ID"></el-table-column>
        <el-table-column prop="user_name"
                         key="user_name"
                         label="用户名"></el-table-column>
        <el-table-column prop="department_name"
                         key="department_name"
                         label="部门"></el-table-column>
        <el-table-column prop="department_job_name"
                         key="department_job_name"
                         label="岗位"></el-table-column>
        <el-table-column prop="realname"
                         key="realname"
                         label="员工姓名"></el-table-column>
        <el-table-column prop="first_approver_name"
                         key="first_approver_name"
                         label="一级审批人"></el-table-column>
        <el-table-column prop="second_approver_name"
                         key="second_approver_name"
                         label="二级审批人"></el-table-column>
        <el-table-column prop="third_approver_name"
                         key="third_approver_name"
                         label="三级审批人"></el-table-column>
        <el-table-column prop="fourth_approver_name"
                         key="fourth_approver_name"
                         label="四级审批人"></el-table-column>
        <el-table-column prop="name"
                         key="name"
                         label="账户名称"></el-table-column>
        <el-table-column prop="bank_account"
                         key="bank_account"
                         label="银行账号"></el-table-column>
        <el-table-column prop="bank"
                         key="bank"
                         label="开户银行支行"></el-table-column>
        <el-table-column prop="bank_headquarters"
                         key="bank_headquarters"
                         label="开户银行总行"></el-table-column>

        <el-table-column fixed="right"
                         label="操作"
                         :key="`operation`"
                         width="150">
          <template slot-scope="scope">
            <el-button type="primary"
                       @click="editUserBank(scope.row.id)"
                       size="mini">修改
            </el-button>
            <el-button type="danger"
                       size="mini"
                       @click="onDelete(scope.row.id)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <user-bank-form-dialog :visible="dialogVisible"
                           :id="dialogId"
                           :title="dialogTitle"
                           @closeDialog="closeDialog"
                           @closeDialogRefresh="closeDialogRefresh">
    </user-bank-form-dialog>

  </div>
</template>

<script>
import table from '@core/mixins/table'
import UserBankFormDialog from '@views/user-bank-account/components/UserBankFormDialog'

export default {
  mixins: [table],
  components: {
    UserBankFormDialog
  },
  data () {
    return {
      search: {
        user_id: null,
        name: null,
      },
      searchFieldType: {
        user_id: Number,
      },
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
      },
      dialogTitle: '',
      dialogVisible: false,
      dialogId: 0,
      exportHeader: [
        {
          key: 'id',
          text: 'ID'
        },
        {
          key: 'user_name',
          text: '用户名'
        },
        {
          key: 'department_name',
          text: '部门'
        },
        {
          key: 'department_job_name',
          text: '岗位'
        },
        {
          key: 'realname',
          text: '员工姓名'
        },
        {
          key: 'first_approver_name',
          text: '一级审批人'
        },
        {
          key: 'second_approver_name',
          text: '二级审批人'
        },
        {
          key: 'third_approver_name',
          text: '三级审批人'
        },
        {
          key: 'fourth_approver_name',
          text: '四级审批人'
        },
        {
          key: 'name',
          text: '账户名称'
        },
        {
          key: 'bank_account',
          text: '银行账号'
        },
        {
          key: 'bank',
          text: '开户银行支行'
        },
        {
          key: 'bank_headquarters',
          text: '开户银行总行'
        },
      ],
    }
  },
  computed: Vuex.mapState({}),
  methods: {
    ...Vuex.mapActions(['getPlatformUsersDetail', 'getPlatformUsersIndex']),

    /**
     * 获得表格数据
     * @param {*} params
     *
     */
    getTableData (params) {
      return request.page('getUserBankAccountTable', params)
    },
    createUserBank () {
      request.loading('createUserBankAccount', {'is_test_permission': 1}).then(_ => {
        this.dialogTitle = '添加员工账户'
        this.dialogVisible = true
        this.dialogId = 0
      }).catch(_ => {
        this.$message.error('抱歉，您没有权限执行此操作')
      })
    },
    batchCreateUserBank () {
      request.loading('batchCreateUserBankAccount', {'is_test_permission': 1}).then(_ => {
        this.$router.push('/user-bank-account/create/batch')
      }).catch(_ => {
        this.$message.error('抱歉，您没有权限执行此操作')
      })
    },
    batchEditUserBank () {
      request.loading('batchEditUserBankAccount', {'is_test_permission': 1}).then(_ => {
        this.$router.push('/user-bank-account/edit/batch')
      }).catch(_ => {
        this.$message.error('抱歉，您没有权限执行此操作')
      })
    },
    editUserBank (id) {
      request.loading('updateUserBankAccount', {id, 'is_test_permission': 1}).then(_ => {
        this.dialogTitle = '修改员工账户'
        this.dialogVisible = true
        this.dialogId = id * 1
      }).catch(_ => {
        this.$message.error('抱歉，您没有权限执行此操作')
      })
    },
    onDelete (id) {
      // 测试有删除权限后，在进行删除
      let uri = 'delUserBankAccountById'
      request.loading(uri, {id, 'is_test_permission': 1}).then(_ => {
        this.$confirm('确定要删除吗？', '警告', {type: 'warning'}).then(_ => {
          request.common(uri, {id}).then(_ => {
            this.$message.success('删除成功')
            this.onSearch()
          })
        })
      }).catch(_ => {
        this.$message.error('抱歉，您没有权限执行此操作')
      })
    },
    resetSearch () {
      this.$refs[this.refSearchForm].resetFields()
    },
    getExportData (params) {
      return request.page('getUserBankAccountTable', params)
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getExportData,
        requestParams: this.search,
        getResponseData: (data) => {
          return data
        }
      })
    },
    closeDialog () {
      this.dialogVisible = false
      this.dialogId = 0
    },
    closeDialogRefresh () {
      this.closeDialog()
      this.$router.go(0)
    },
  },
}
</script>


<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/user-bank-account/pages/UserAccountTable.vue